import React from 'react';
import { BrowserRouter, Routes, Route, NavLink } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { NotificationProvider } from './context/NotificationContext';
import ProtectedRoute from './components/common/ProtectedRoute';
import NotificationPanel from './components/Notifications/NotificationPanel';
import DashboardPage from './pages/DashboardPage';
import AlertsPage from './pages/AlertsPage';
import TcgReferencePage from './pages/TcgReferencePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import AdminPage from './pages/AdminPage';
import './App.css';

function AppHeader() {
  const { user, logout } = useAuth();

  if (!user) return null;

  return (
    <header className="app-header">
      <div className="header-left">
        <h1 className="app-title">Pokemon Card Tracker</h1>
        <nav className="app-nav">
          <NavLink to="/" end className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
            Cards
          </NavLink>
          <NavLink to="/alerts" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
            Alerts
          </NavLink>
          <NavLink to="/tcg" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
            TCG Reference
          </NavLink>
          {user.is_admin && (
            <NavLink to="/admin" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
              Admin
            </NavLink>
          )}
        </nav>
      </div>
      <div className="header-right">
        <NotificationPanel />
        <div className="user-menu">
          <span className="user-name">{user.username}</span>
          <button className="btn btn-sm btn-logout" onClick={logout}>
            Logout
          </button>
        </div>
      </div>
    </header>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <NotificationProvider>
          <div className="app">
            <AppHeader />
            <main className="app-main">
              <Routes>
                {/* Public routes */}
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />

                {/* Protected routes */}
                <Route path="/" element={
                  <ProtectedRoute><DashboardPage /></ProtectedRoute>
                } />
                <Route path="/alerts" element={
                  <ProtectedRoute><AlertsPage /></ProtectedRoute>
                } />
                <Route path="/tcg" element={
                  <ProtectedRoute><TcgReferencePage /></ProtectedRoute>
                } />
                <Route path="/admin" element={
                  <ProtectedRoute><AdminPage /></ProtectedRoute>
                } />
              </Routes>
            </main>
          </div>
        </NotificationProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
